import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/launch-checklist")({
  component: lazyRouteComponent(() => import("./-pages/admin.launch-checklist")),
  head: () => ({
    meta: [
      { title: "Admin · Launch Checklist — Lecmo" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
